module.exports = __webpack_public_path__ + "img/4fdd4c4f296e430dc72b6825350718ea.svg";